/* eslint-disable no-console */
import React, { useState } from "react";
import { Form, Popup } from "semantic-ui-react";
import { useFormik } from "formik";
import { PaymentCategory } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { ListPaymentConcept } from "../ListPaymentConcept";
import { initialValues, validationSchema } from "./PaymentConceptForm.form";
import "./PaymentConceptForm.scss";

const paymentCategoryController = new PaymentCategory();

export function PaymentConceptForm(props) {
  const { paymentCategory } = props;
  const [reload, setReload] = useState(null);
  const { accessToken } = useAuth();

  const onReload = () => setReload((prevState) => !prevState);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          name: formValue.name,
          amount: formValue.amount,
          dueDate: formValue.dueDate,
          paymentCategoryId: paymentCategory.id,
        };

        await paymentCategoryController.createPaymentConcept(accessToken, data);
        formik.resetForm();
        onReload();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <div className="payment-concept__container">
      <Form className="payment-concept__form" onSubmit={formik.handleSubmit}>
        <div className="payment-concept__form-fields">
          <Form.Input
            name="name"
            label="Nombre de concepto de pago"
            onChange={formik.handleChange}
            value={formik.values.name}
            error={formik.errors.name}
            fluid
          />
          <div className="payment-concept__form-row">
            <Form.Input
              name="amount"
              type="number"
              label="S/. Monto"
              onChange={formik.handleChange}
              value={formik.values.amount}
              error={formik.errors.amount}
            />
            <Form.Input
              name="dueDate"
              type="date"
              label="Fecha de vencimiento"
              onChange={formik.handleChange}
              value={formik.values.dueDate}
              error={formik.errors.dueDate}
            />
          </div>
          <Form.Button
            type="submit"
            primary
            fluid
            loading={formik.isSubmitting}
            className="payment-concept__submit-btn"
          >
            Agregar concepto de pago
          </Form.Button>
        </div>
      </Form>
      <div className="payment-concept__list">
        <ListPaymentConcept
          paymentCategoryId={paymentCategory.id}
          reload={reload}
          onReload={onReload}
        />
      </div>
    </div>
  );
}
